import React, { useRef, useState, useEffect } from "react";
import { TourneyGamesSort } from "@themed-components";
import { CashGamesSort } from "@themed-components";

const A23TabBarV2 = ({
  tabs,
  activeTab,
  onTabChange,
  isTourney,
  removeFilter,
  setRemoveFilter,
  showSort = true,
}) => {
  const containerRef = useRef(null);
  const [showLeftShadow, setShowLeftShadow] = useState(false);
  const [showRightShadow, setShowRightShadow] = useState(false);

  const checkShadows = () => {
    const el = containerRef.current;
    if (!el) return;
    const { scrollLeft, scrollWidth, clientWidth } = el;
    setShowLeftShadow(scrollLeft > 0);
    setShowRightShadow(scrollLeft + clientWidth < scrollWidth - 1);
  };

  const scrollActiveTabToCenter = () => {
    const el = containerRef.current;
    if (!el || !tabs.length) return;
    const activeTabIndex = tabs.findIndex(
      (tab) => tab.gameType === activeTab.gameType
    );
    if (activeTabIndex === -1) return;
    const activeTabElement = el.children[activeTabIndex];
    if (activeTabElement) {
      activeTabElement.scrollIntoView({
        behavior: "smooth",
        inline: "center",
        block: "nearest",
      });
      setTimeout(() => {
        checkShadows();
      }, 300);
    }
  };

  useEffect(() => {
    if (activeTab?.gameType && tabs.length > 0) {
      const timeoutId1 = setTimeout(() => {
        scrollActiveTabToCenter();
      }, 50);
      const timeoutId2 = setTimeout(() => {
        scrollActiveTabToCenter();
      }, 200);
      const timeoutId3 = setTimeout(() => {
        scrollActiveTabToCenter();
      }, 500);

      return () => {
        clearTimeout(timeoutId1);
        clearTimeout(timeoutId2);
        clearTimeout(timeoutId3);
      };
    }
  }, [activeTab?.gameType, tabs]);

  useEffect(() => {
    if (tabs.length > 0 && activeTab?.gameType) {
      const timeoutId = setTimeout(() => {
        scrollActiveTabToCenter();
      }, 100);

      return () => clearTimeout(timeoutId);
    }
  }, [tabs.length, activeTab?.gameType]);
  const handleTabClick = (tab, index) => {
    onTabChange(tab);
    const el = containerRef.current;
    if (el) {
      const activeTabElement = el.children[index];
      if (activeTabElement) {
        activeTabElement.scrollIntoView({
          behavior: "smooth",
          inline: "center",
          block: "nearest",
        });
      }
    }
  };

  useEffect(() => {
    const el = containerRef.current;
    if (!el) return;
    checkShadows();
    el.addEventListener("scroll", checkShadows);
    window.addEventListener("resize", checkShadows);
    const observer = new MutationObserver(checkShadows);
    observer.observe(el, { childList: true, subtree: true, attributes: true });
    return () => {
      el.removeEventListener("scroll", checkShadows);
      window.removeEventListener("resize", checkShadows);
      observer.disconnect();
    };
  }, []);

  return (
    <div className="flex items-center gap-2 shadow-inner bg-foreground">
      {showLeftShadow && (
        <div className="pointer-events-none absolute top-0 left-0 z-10 h-full w-8 bg-gradient-to-r from-foreground via-foreground/80 to-transparent" />
      )}

      <div
        ref={containerRef}
        className="flex flex-1 ml-3 items-center flex-nowrap overflow-x-auto scrollbar-hide"
      >
        {tabs.map((tab, idx) => (
          <>
            <button
              key={idx}
              onClick={() => handleTabClick(tab, idx)}
              className={`
              flex-shrink-0  relative overflow-hidden bg-red-500s flex items-center p-2.5 text-sm font-medium transition-colors duration-200
              ${
                activeTab.gameType === tab.gameType
                  ? "text-gold-primary border-b-2 border-active-tab-2 text-sm font-medium"
                  : "text-sm font-normal border-b-2 border-transparent text-secondary"
              }
            `}
            >
              {tab?.tabIcon && (
                <img
                  src={tab?.tabIcon}
                  alt="Tab Icon"
                  className="w-4 h-4 mr-2 object-cover"
                />
              )}
              {activeTab.gameType === tab.gameType ? (
                <div className="h-2 bg-linear-to-t w-[40%] left-[30%] rounded-200 from-gold-primary from-30% to-gold-secondary/0 blur-[12px] absolute bottom-0" />
              ) : (
                <div />
              )}
              {tab.name}
            </button>
          </>
        ))}
      </div>

      {showRightShadow && (
        <div className="pointer-events-none absolute top-0 right-12 h-full w-8 bg-gradient-to-l from-foreground via-foreground/80 to-transparent" />
      )}

      <div className="pr-4 flex items-center">
        {showSort &&
          (isTourney ? (
            <TourneyGamesSort
              removeFilter={removeFilter}
              setRemoveFilter={setRemoveFilter}
            />
          ) : (
            <CashGamesSort />
          ))}
      </div>
    </div>
  );
};

export default A23TabBarV2;
